<template>
  <v-card>
    <v-card-text>
      <template>
        <v-row>
          <v-col cols="4">
            <v-autocomplete
              ref="supplier_id"
              :items="suppliers"
              label="Seleccione proveedor"
              outlined
              :item-text="customText"
              item-value="id"
              clearable
              :value="supplier_id"
              :loading="isLoading"
              @change="set_supplier_id"
              v-on:keyup.enter="searchSupplier($event)"
              :rules="[
                () => !!supplier_id || 'Es necesario seleccionar un proveedor',
              ]"
              hide-details="auto"
              required
            ></v-autocomplete>

            <!-- <v-autocomplete
              ref="supplier_id"
              :items="suppliers"
              label="Seleccione proveedor"
              outlined
              :item-text="customText"
              item-value="id"
              clearable
              :value="supplier_id"
              @change="set_supplier_id"
              :rules="[
                () => !!supplier_id || 'Es necesario seleccionar un proveedor',
              ]"
              hide-details="auto"
              required
            ></v-autocomplete> -->
          </v-col>
          <v-col cols="4">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  ref="register_date"
                  :value="register_date"
                  label="Fecha"
                  readonly
                  clearable
                  v-on="on"
                  outlined
                  :rules="[
                    () => !!register_date || 'Es necesario ingresar una fecha',
                  ]"
                  hide-details="auto"
                  required
                ></v-text-field>
              </template>
              <v-date-picker
                :value="register_date"
                @input="menu1 = false"
                no-title
                @change="set_register_date"
                locale="es"
              >
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="4">
            <v-autocomplete
              ref="storehouse_id"
              :value="storehouse_id"
              :items="storehouses"
              label="Almacén"
              outlined
              :item-text="customText"
              item-value="id"
              @change="set_storehouse_id"
              :rules="[
                () => !!storehouse_id || 'Es necesario seleccionar almacén',
              ]"
              hide-details="auto"
              required
            ></v-autocomplete>
          </v-col>

          <v-col cols="4">
            <v-autocomplete
              ref="origin_id"
              :value="origin_id"
              :items="origins"
              label="Origen"
              outlined
              :item-text="customText"
              item-value="origin_id"
              :rules="[
                () => !!origin_id || 'Es necesario seleccionar el origen',
              ]"
              hide-details="auto"
              required
              @change="set_origin_id"
            ></v-autocomplete>
          </v-col>

          <v-col cols="4" v-if="origin_id == 'CUENTA BANCARIA'">
            <v-autocomplete
              ref="account_id"
              :items="accounts"
              label="Cuentas"
              outlined
              :item-text="customTextV2"
              item-value="id"
              clearable
              :value="account_id"
              @change="set_account_id"
              hide-details="auto"
              required
            ></v-autocomplete>
          </v-col>

          <v-col cols="4" v-if="origin_id == 'CAJA'">
            <v-autocomplete
              ref="till_id"
              :value="till_id"
              :items="tills"
              label="Cajas"
              outlined
              :item-text="customText"
              item-value="id"
              @change="set_till_id"
              hide-details="auto"
              required
            ></v-autocomplete>
          </v-col>

          <v-col cols="4">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  ref="register_date_emision"
                  :value="register_date_emision"
                  label="Fecha de emision"
                  readonly
                  clearable
                  v-on="on"
                  outlined
                  :rules="[
                    () =>
                      !!register_date_emision ||
                      'Es necesario ingresar una fecha',
                  ]"
                  hide-details="auto"
                  required
                ></v-text-field>
              </template>
              <v-date-picker
                :value="register_date_emision"
                @input="menu2 = false"
                no-title
                @change="set_register_date_emision"
                locale="es"
              >
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="4">
            <v-autocomplete
              ref="tipo_moneda"
              :value="tipo_moneda"
              :items="moneda"
              label="Tipo de Moneda"
              outlined
              :item-text="customText"
              item-value="tipo_moneda"
              :rules="[
                () => !!tipo_moneda || 'Es necesario seleccionar el origen',
              ]"
              hide-details="auto"
              required
              @change="set_tipo_moneda"
            ></v-autocomplete>
          </v-col>
          <v-col cols="4" v-if="tipo_moneda === 'DOLARES'">
            <v-text-field
              ref="tipo_cambio"
              :value="tipo_cambio"
              label="Tipo de Cambio"
              outlined
              @input="set_tipo_cambio"
              :rules="[
                () => !!tipo_cambio || 'Es necesario seleccionar la serie',
              ]"
              hide-details="auto"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-switch
              :value="credit_purchase"
              class="mt-0"
              label="COMPRA AL CRÉDITO"
              hide-details
              :false-value="false"
              :true-value="true"
              @change="handleChangeCreditPurchase"
            ></v-switch>
          </v-col>
          <v-col cols="4" v-if="credit_purchase == true">
            <v-menu
              v-model="menuDatePayment"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="date_payment"
                  label="Fecha de pago"
                  readonly
                  clearable
                  outlined
                  dense
                  v-on="on"
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                :value="date_payment"
                @input="menuDatePayment = false"
                no-title
                locale="es"
                :min="date_payment_min"
                @change="set_date_payment"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "Header",
  data() {
    return {
      menu2: false,
      menu1: false,
      dolar: false,
      menuDatePayment: false,
      date_payment_min: new Date().toISOString().substr(0, 10),
      origins: ["CAJA", "CUENTA BANCARIA"],
      moneda: ["SOLES", "DOLARES"],
      isLoading: false,
      //origin_id: null,
    };
  },
  computed: {
    ...mapState("suppliers", ["suppliers"]),
    ...mapState("purchases", [
      "supplier_id",
      "register_date",
      "register_date_emision",
      "tipo_cambio",
      "tipo_moneda",
      "sale_order",
      "credit_purchase",
      "date_payment",
      "storehouse_id",
      "origin_id",
      "account_id",
      "till_id",
      //'set_origin_id'
    ]),
    ...mapState("storehouses", ["storehouses"]),
    /* actualiza*/
    ...mapState("accounts", [
      "accounts",
      //'account_id'
    ]),
    ...mapState("tills", [
      "tills",
      //'till_id'
    ]),
  },
  methods: {
    ...mapMutations("purchases", [
      "set_supplier_id",
      "set_register_date",
      "set_register_date_emision",
      "set_tipo_cambio",
      "set_tipo_moneda",
      "set_sale_order",
      "set_credit_purchase",
      "set_date_payment",
      "set_storehouse_id",
      "set_origin_id",
      "set_till_id",
      "set_account_id",
    ]),
    ...mapActions("suppliers", ["getSuppliers"]),
    ...mapActions("purchases", ["clean_data"]),
    ...mapActions("storehouses", ["getStorehouses"]),
    ...mapActions("accounts", [
      "getAccounts",
      //'set_account_id'
    ]),
    ...mapActions("tills", ["getTills"]),
    customText(item) {
      let text = item.name;
      return text;
    },
    customTextV2(item) {
      let text = item.bank.name + " (" + item.number_account + ")";
      return text;
    },
    existErrors() {
      let hasErrors = false;

      Object.keys(this.sedeForm).forEach((f) => {
        if (this.$refs[f]) {
          if (!this.sedeForm[f]) hasErrors = true;
          this.$refs[f].validate(true);
        }
      });

      return hasErrors;
    },
    clearErrors() {
      Object.keys(this.sedeForm).forEach((f) => {
        if (this.$refs[f]) this.$refs[f].reset();
      });
    },
    handleChangeCreditPurchase(value) {
      this.set_credit_purchase(value);
      if (this.credit_purchase == false) {
        this.set_date_payment(null);
      }
    },
    handleChangeOrigin(value) {
      //console.log(value);
      //this.set_origin_id;
      this.origin_id = value;
    },
    async searchSupplier(event) {
      this.isLoading = true;
      const value = event.target.value;
      if (value.length > 0) {
        await this.getSuppliers({ name: value });
      } else {
        await this.getSuppliers();
      }
      this.isLoading = false;
    },
  },
  created() {
    // this.getSuppliers({ active: true });
    // this.getStorehouses();
    // this.getAccounts();
    // this.getTills();
  },
  mounted() {},
};
</script>

<style scoped></style>
